import React from 'react';
import Registration from '../../components/registration';
import { Helmet } from 'react-helmet';

export default () => <>
    <Helmet title='Envie seu imóvel!!'/>
    <Registration/>
</>